import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function SentEmail(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "SentEmail", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m45.75 17.25-1.5 12c0 .7956-.3161 1.5587-.8787 2.1213-.5626.5626-1.3257.8787-2.1213.8787h-19.5c-.7956 0-1.5587-.3161-2.1213-.8787-.5626-.5626-.8787-1.3257-.8787-2.1213l1.5-12c0-.7956.3161-1.5587.8787-2.1213.5626-.5626 1.3257-.8787 2.1213-.8787h19.5c.7956 0 1.5587.3161 2.1213.8787.5626.5626.8787 1.3257.8787 2.1213Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m44.745 15-12.33 8.3025c-.2623.2019-.584.3114-.915.3114-.331 0-.6527-.1095-.915-.3114L21.255 15c.5508-.4858 1.2606-.7526 1.995-.75h19.5c.7344-.0026 1.4442.2642 1.995.75Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15 27.75H3c-.19891 0-.38968-.079-.53033-.2197C2.32902 27.3897 2.25 27.1989 2.25 27c0-.1989.07902-.3897.21967-.5303.14065-.1407.33142-.2197.53033-.2197h12c.1989 0 .3897.079.5303.2197.1407.1406.2197.3314.2197.5303 0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197Zm.75-3.75h-7.5c-.19891 0-.38968-.079-.53033-.2197C7.57902 23.6397 7.5 23.4489 7.5 23.25c0-.1989.07902-.3897.21967-.5303.14065-.1407.33142-.2197.53033-.2197h7.5c.1989 0 .3897.079.5303.2197.1407.1406.2197.3314.2197.5303 0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197Zm.75-3.75h-3.75c-.1989 0-.3897-.079-.5303-.2197C12.079 19.8897 12 19.6989 12 19.5c0-.1989.079-.3897.2197-.5303.1406-.1407.3314-.2197.5303-.2197h3.75c.1989 0 .3897.079.5303.2197.1407.1406.2197.3314.2197.5303 0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
SentEmail.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "SentEmail"
};
validateTidalLicense();
export {
  SentEmail
};
//# sourceMappingURL=SentEmail.js.map
